import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

export const SCHEDULE_SETTINGS_REQUEST = 'SCHEDULE_SETTINGS_REQUEST';
export const SCHEDULE_SETTINGS_SUCCESS = 'SCHEDULE_SETTINGS_SUCCESS';
export const SCHEDULE_SETTINGS_FAILURE = 'SCHEDULE_SETTINGS_FAILURE';
export const SCHEDULE_SETTINGS_NOT_FOUND = 'SCHEDULE_SETTINGS_NOT_FOUND';

export const fetchScheduleSettings = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_SETTINGS_REQUEST });
    return axios(apiRequestOptions(apiPath.COMPETITION_SCHEDULE_SETTINGS.GET, null, { params: { id: competitionId } }))
      .then(transformHttpResponse)
      .then(response => dispatch({ type: SCHEDULE_SETTINGS_SUCCESS, data: response.data }))
      .catch(error => {
        if (error.response && error.response.status === 404) {
          dispatch({ type: SCHEDULE_SETTINGS_NOT_FOUND });
          return;
        }
        return transformHttpResponse(error.response);
      })
      .catch(error => {
        dispatch({ type: SCHEDULE_SETTINGS_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
